import { orElse, value as value_97, some, unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { MenuItem, Select, List, ListItemText, ListItemIcon, ListItem, TableFooter, TablePagination, TableBody, TableHead, TableRow, Table, TableCell, DialogActions, Button, DialogContent, Divider, IconButton, Tooltip, Tab, Tabs, DialogTitle, Dialog, Alert, Collapse, Typography, TextField, FormControl, Checkbox, FormControlLabel } from "@mui/material";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { ctx as ctx_1 } from "../Context.js";
import { DocumentTreeVersions_Audit_toString, DocumentTrees_Audit_toString, AuditLogs_Actions_FromId, Documents_TreeSyncRule__ToLocalizedString_12C6553D, Documents_TreeSyncRule__get_Id, Documents_TreeSyncRule_AllRules } from "../Shared/Shared.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { API_Machine_CategoryVersion, generateQueryString } from "../Shared/Urls.js";
import { equals, comparePrimitives, defaultOf, createObj, uncurry2, int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { fromString as fromString_1, Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { DocumentTreeVersion_$reflection, DocumentTreeAuditLog_$reflection, GenericResponse_$reflection, DocumentCategory_$reflection, DocumentCategory, DocumentTreeSyncRule, DocumentTreeSyncRule_$reflection } from "../Shared/ApiDataTypes.js";
import { unit_type, obj_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { corsProps, testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { skeletonList, onPageChange, skeletonRows, loadingIndicatorSmall, errorBanner } from "../ViewHelpers.js";
import { maxBy, tryPick, sortBy, sortByDescending, append, tryFind, collect, map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { emptyCategory } from "../Documents/DocumentHelpers.js";
import { printf, toText, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import Warning from "@mui/icons-material/Warning";
import { defaultOf as defaultOf_1 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { toArray, empty as empty_1, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import Help from "@mui/icons-material/Help";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import { toLongTimeString, toShortDateString, compare } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { actionStr } from "../AuditLogs.js";
import { toDateAndTimeStr } from "../Locale.js";
import Star from "@mui/icons-material/Star";
import StarBorder from "@mui/icons-material/StarBorder";

export function getRefValue(ref) {
    return defaultArg(map((elem) => elem.value, ref.current), "");
}

export function categoryCheckbox(id, label, onChange, value) {
    return MuiHelpers_createElement(FormControlLabel, [["labelPlacement", "end"], ["label", label], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"], ["id", id], ["checked", value], ["onChange", (e) => {
        onChange(e.target.checked);
    }]])]]);
}

/**
 * Draw render out in own function with unique keys to force react to acknowledge two different inputs based on language
 */
export function drawNameInput(defaultVal, inputKey, onChange) {
    let elements;
    return MuiHelpers_createElement(FormControl, [["key", inputKey], ["style", {
        width: 100 + "%",
        marginTop: 10 + "px",
    }], (elements = [MuiHelpers_createElement(TextField, [["key", inputKey], ["variant", "outlined"], ["size", "small"], ["id", inputKey], ["label", "Kategorinavn"], ["defaultValue", defaultVal], ["autoFocus", true], ["onChange", (e) => {
        onChange(e.target.value);
    }], ["fullWidth", true]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

/**
 * Draw render out in own function with unique keys to force react to acknowledge two different inputs based on language
 */
export function nameInputWithRef(label, inputKey, current, ref) {
    let elements;
    return MuiHelpers_createElement(FormControl, [["key", inputKey], ["style", {
        width: 100 + "%",
        marginTop: 10 + "px",
    }], (elements = [MuiHelpers_createElement(TextField, [["key", inputKey], ["variant", "outlined"], ["size", "small"], ["id", inputKey], ["inputRef", ref], ["autoFocus", true], ["fullWidth", true], ["label", label], ["defaultValue", current]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

export function descriptionInput(id, label, current, ref) {
    return MuiHelpers_createElement(TextField, [["id", id], ["minRows", 3], ["variant", "outlined"], ["multiline", true], ["fullWidth", true], ["inputRef", ref], ["label", label], ["defaultValue", current]]);
}

function SyncTargetSelect(syncTargetSelectInputProps) {
    let elems_4, value_15, elems_3, elems_2;
    const category = syncTargetSelectInputProps.category;
    const onChange = syncTargetSelectInputProps.onChange;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(true);
    const patternInput_1 = reactApi.useState([]);
    const syncRules = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const patternInput_3 = reactApi.useState(undefined);
    let allSelected;
    const array_1 = Documents_TreeSyncRule_AllRules();
    allSelected = array_1.every((rule) => category.SyncRules.some((currentRule) => (Documents_TreeSyncRule__get_Id(rule) === currentRule.TargetId)));
    const anySelected = category.SyncRules.some((rule_1) => syncRules.some((currentRule_1) => {
        if (rule_1.TreeId === category.Id) {
            return rule_1.TargetId === currentRule_1.TargetId;
        }
        else {
            return false;
        }
    }));
    useEffectOnce(() => {
        let properties_2;
        const url = "/api/document-tree/admin/sync-rules" + generateQueryString([["version", defaultArg(map(int32ToString, category.Version), "")]]);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(DocumentTreeSyncRule_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg_1) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(DocumentTreeSyncRule_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                patternInput_1[1](res.fields[0]);
            }
            else {
                console.error(some("Could not fetch sync rules"), res.fields[0]);
            }
            patternInput[1](false);
        });
    });
    const xs_4 = [errorBanner(patternInput_3[0], () => {
        patternInput_3[1](undefined);
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
        gap: 5 + "px ",
    }], (elems_4 = [MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", "Synkregler"]]), MuiHelpers_createElement(Typography, [["variant", "body2"], (value_15 = "Velg fra denne listen hvilken typer Vismadokumenter som skal automatisk bli lagt til denne kategorien.", ["children", value_15])]), createElement("div", createObj(ofArray([["style", {
        margin: 10 + "px",
    }], (elems_3 = [MuiHelpers_createElement(FormControlLabel, [["label", "Alle"], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"], ["onChange", (e) => {
        if (e.target.checked) {
            onChange(map_1((rule_2) => (new DocumentTreeSyncRule(Documents_TreeSyncRule__get_Id(rule_2), category.Id, category.NameEN)), Documents_TreeSyncRule_AllRules()));
        }
        else {
            onChange([]);
        }
    }], ["indeterminate", !allSelected && anySelected], ["checked", allSelected]])]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        marginLeft: 16 + "px",
    }], (elems_2 = [collect((r) => {
        let elements_1, elements, sr;
        const selected = category.SyncRules.some((rule_4) => {
            if (rule_4.TargetId === Documents_TreeSyncRule__get_Id(r)) {
                return rule_4.TreeId === category.Id;
            }
            else {
                return false;
            }
        });
        const existingRuleOpt = tryFind((existing) => {
            if (selected && (existing.TargetId === Documents_TreeSyncRule__get_Id(r))) {
                return existing.TreeId !== category.Id;
            }
            else {
                return false;
            }
        }, syncRules);
        return [MuiHelpers_createElement(FormControlLabel, [["label", Documents_TreeSyncRule__ToLocalizedString_12C6553D(r, ctx.Language)], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"], ["onChange", (e_1) => {
            if (e_1.target.checked) {
                onChange(append(category.SyncRules, [new DocumentTreeSyncRule(Documents_TreeSyncRule__get_Id(r), category.Id, category.NameNO)]));
            }
            else {
                onChange(category.SyncRules.filter((rule_3) => {
                    if (rule_3.TreeId === category.Id) {
                        return rule_3.TargetId !== Documents_TreeSyncRule__get_Id(r);
                    }
                    else {
                        return false;
                    }
                }));
            }
        }], ["checked", selected]])]]), MuiHelpers_createElement(Collapse, [["in", existingRuleOpt != null], (elements_1 = [MuiHelpers_createElement(Alert, [["style", {}], ["severity", "warning"], ["variant", "filled"], (elements = [createElement("span", {
            style: {},
            children: (existingRuleOpt == null) ? "" : ((sr = value_97(existingRuleOpt), `${ctx.Locale.t("DocumentTree.Admin.RuleAlreadyAssigned", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["TreeName", sr.TreeName]))}`)),
        })], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])];
    }, Documents_TreeSyncRule_AllRules())], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))];
    return react.createElement(react.Fragment, {}, ...xs_4);
}

/**
 * Component for adding or updating tree-nodes/document folder/categories
 */
export function BranchForm(branchFormInputProps) {
    let elements_4, children_2, elems_8, elems_4, elems_3, elements, props_3, elems_1, elems_2, elems_7, elems_6, elements_1, props_11, children_3;
    const onClose = branchFormInputProps.onClose;
    const parent = branchFormInputProps.parent;
    const updating = branchFormInputProps.updating;
    const version = branchFormInputProps.version;
    const isOpen = branchFormInputProps.isOpen;
    const key = branchFormInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    const patternInput_2 = reactApi.useState(0);
    const textLang = patternInput_2[0] | 0;
    const setTextLang = patternInput_2[1];
    const descNoRef = reactApi.useRef(undefined);
    const descEnRef = reactApi.useRef(undefined);
    let patternInput_3;
    const initial_3 = defaultArg(updating, emptyCategory(version, parent));
    patternInput_3 = reactApi.useState(initial_3);
    const updateForm = patternInput_3[1];
    const branchForm = patternInput_3[0];
    const handleClose = (categoryOpt) => {
        setProcessing(false);
        setErrMsg(undefined);
        onClose(categoryOpt);
        if (categoryOpt != null) {
            updateForm(emptyCategory(version, parent));
            setTextLang(0);
        }
    };
    const dependencies = [isOpen];
    reactApi.useEffect(() => {
        if (isOpen) {
            updateForm(defaultArg(updating, emptyCategory(version, parent)));
        }
    }, dependencies);
    let title;
    if (updating == null) {
        if (parent == null) {
            title = ctx.Locale.t("DocumentTree.Admin.AddMainFolder");
        }
        else {
            const p = parent;
            const parentCategory = (ctx.Language.tag === 1) ? p.NameEN : p.NameNO;
            title = ctx.Locale.t("DocumentTree.Admin.AddChildUnder", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["folderName", parentCategory]));
        }
    }
    else {
        const node = updating;
        const nodeName = (ctx.Language.tag === 1) ? node.NameEN : node.NameNO;
        title = ctx.Locale.t("DocumentTree.Admin.EditFolder", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["folderName", nodeName]));
    }
    return MuiHelpers_createElement(Dialog, [["style", {}], ["maxWidth", "sm"], ["open", isOpen], ["onClose", (_arg_6, v) => {
        handleClose(undefined);
    }], (elements_4 = [MuiHelpers_createElement(DialogTitle, [["children", title]]), (children_2 = ofArray([createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems_8 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 20 + "px",
    }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        rowGap: 10 + "px",
    }], (elems_3 = [MuiHelpers_createElement(Tabs, [["style", {
        maxWidth: 100 + "%",
    }], ["variant", "fullWidth"], ["indicatorColor", "primary"], ["textColor", "primary"], ["centered", true], ["value", textLang], ["onChange", (_arg_7, v_1) => {
        setTextLang(v_1);
    }], (elements = [MuiHelpers_createElement(Tab, [["label", "Norsk"]]), MuiHelpers_createElement(Tab, [["icon", isNullOrWhiteSpace(branchForm.NameEN) ? ((props_3 = {}, react.createElement(Warning, props_3))) : defaultOf_1()], ["label", "English"]])], ["children", reactApi.Children.toArray(Array.from(elements))])]), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1((textLang !== 0) ? singleton(["display", "none"]) : singleton(["display", "flex"]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => singleton(["rowGap", 10 + "px"]))))))))], (elems_1 = [drawNameInput(branchForm.NameNO, "no-name-input", (n) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, branchForm.Enabled, branchForm.PtgOnly, branchForm.AllowUpload, branchForm.AllowMachineSubCategories, n, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }), descriptionInput("no-desc-input", "Norsk beskrivelse", branchForm.DescNO, descNoRef)], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1((textLang !== 1) ? singleton(["display", "none"]) : singleton(["display", "flex"]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => singleton(["rowGap", 10 + "px"]))))))))], (elems_2 = [drawNameInput(branchForm.NameEN, "en-name-input", (n_1) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, branchForm.Enabled, branchForm.PtgOnly, branchForm.AllowUpload, branchForm.AllowMachineSubCategories, branchForm.NameNO, n_1, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }), descriptionInput("en-desc-input", "Engelsk beskrivelse", branchForm.DescEN, descEnRef)], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
    }], (elems_7 = [categoryCheckbox("category-enabled-checkbox", ctx.Locale.t("DocumentTree.Admin.Enable"), (b) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, b, branchForm.PtgOnly, branchForm.AllowUpload, branchForm.AllowMachineSubCategories, branchForm.NameNO, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }, branchForm.Enabled), categoryCheckbox("ptg-only-checkbox", ctx.Locale.t("DocumentTree.Admin.VisibilityPtgOnly"), (b_1) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, branchForm.Enabled, b_1, branchForm.AllowUpload, branchForm.AllowMachineSubCategories, branchForm.NameNO, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }, branchForm.PtgOnly), categoryCheckbox("allow-upload-checkbox", "Direkte opplastning", (b_2) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, branchForm.Enabled, branchForm.PtgOnly, b_2, branchForm.AllowMachineSubCategories, branchForm.NameNO, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }, branchForm.AllowUpload), createElement("div", createObj(singleton_1((elems_6 = [categoryCheckbox("allow-machine-categories", "Tillat underkategorier per maskin", (b_3) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, branchForm.Enabled, branchForm.PtgOnly, branchForm.AllowUpload, b_3, branchForm.NameNO, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }, branchForm.AllowMachineSubCategories), MuiHelpers_createElement(Tooltip, [["title", "Velg om det er mulig å legge til kategorier på spesifike maskiner. Typisk kan dette være leverandørdokumentasjon til et type anlegg."], ["children", MuiHelpers_createElement(IconButton, [(elements_1 = [(props_11 = {}, react.createElement(Help, props_11))], ["children", reactApi.Children.toArray(Array.from(elements_1))])])]])], ["children", reactApi.Children.toArray(Array.from(elems_6))]))))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), MuiHelpers_createElement(Divider, []), createElement(SyncTargetSelect, {
        onChange: (newRules) => {
            console.debug("Got new sync rules", newRules);
            updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, branchForm.Enabled, branchForm.PtgOnly, branchForm.AllowUpload, branchForm.AllowMachineSubCategories, branchForm.NameNO, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, newRules));
        },
        category: branchForm,
    })], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), errorBanner(patternInput_1[0], () => {
        setErrMsg(undefined);
    })]), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children_2))]])), (children_3 = toList(delay(() => (patternInput[0] ? singleton(loadingIndicatorSmall()) : append_1(singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_9) => {
        handleClose(undefined);
    }]])), delay(() => singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["disabled", (branchForm.NameNO.trim().length === 0) ? true : (branchForm.NameEN.trim().length === 0)], ["children", (updating != null) ? ctx.Locale.t("Update") : ctx.Locale.t("Add")], ["onClick", (_arg_10) => {
        const req = branchForm;
        const getRefValue_1 = (ref) => defaultArg(map((elem) => elem.value, ref.current), "");
        const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => {
            setProcessing(true);
            const f = (updating == null) ? ((url) => ((item) => {
                let properties_2;
                const body = Auto_generateBoxedEncoder_437914C6(DocumentCategory_$reflection(), undefined, undefined, undefined)(item);
                const decoder = Auto_generateBoxedDecoder_Z6670B51(DocumentCategory_$reflection(), undefined, undefined);
                const data_1 = some(body);
                const caseStrategy_3 = undefined;
                const extra_3 = undefined;
                try {
                    const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(DocumentCategory_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })) : ((url_4) => ((item_2) => {
                let properties_6;
                const data_4 = some(Auto_generateBoxedEncoder_437914C6(DocumentCategory_$reflection(), undefined, undefined, undefined)(item_2));
                const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(DocumentCategory_$reflection(), undefined, undefined);
                const data_5 = data_4;
                const caseStrategy_12 = undefined;
                const extra_12 = undefined;
                try {
                    const properties_3_1 = Helper_withProperties(corsProps, (properties_6 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_12), unwrap(extra_12))(data_1_2))]), properties_6), data_5), properties_6)));
                    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url_4, properties_3_1).then((_arg_2) => {
                        let response_3, decoder_1_2;
                        return ((response_3 = _arg_2, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(DocumentCategory_$reflection(), unwrap(caseStrategy_12), unwrap(extra_12))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_3.text().then((_arg_3) => {
                            let matchValue_1;
                            return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_3), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                    }))));
                    return pr_1.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])]))));
                }
                catch (exn_1) {
                    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                }
            }));
            const form = new DocumentCategory(req.Id, req.ParentId, req.Version, req.MachineId, req.Enabled, req.PtgOnly, req.AllowUpload, req.AllowMachineSubCategories, req.NameNO, req.NameEN, getRefValue_1(descNoRef), getRefValue_1(descEnRef), req.SyncRules);
            return f("/api/document-tree/admin")(form).then((_arg_4) => {
                let x_2;
                const res = _arg_4;
                return ((res.tag === 1) ? ((setErrMsg((updating == null) ? "Kunne ikke legge til kategori. Vennligst prøv igjen senere." : "Kunne ikke oppdatere kategori. Vennligst prøv igjen senere."), Promise.resolve())) : ((x_2 = res.fields[0], (console.debug("Got from branch form commit", x_2), (handleClose(x_2), Promise.resolve()))))).then(() => PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => {
                    setProcessing(false);
                    return Promise.resolve();
                }));
            });
        }));
        pr_2.then();
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_3))]]))], ["children", reactApi.Children.toArray(Array.from(elements_4))])]);
}

export function Branch_DeleteFolderForm_145C481D(branch_DeleteFolderForm_145C481DInputProps) {
    let elements_3, elements, elements_2, elements_1;
    const onClose = branch_DeleteFolderForm_145C481DInputProps.onClose;
    const folder = branch_DeleteFolderForm_145C481DInputProps.folder;
    const isOpen = branch_DeleteFolderForm_145C481DInputProps.isOpen;
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const processing = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    const errMsg = patternInput_1[0];
    const handleClose = () => {
        setErrMsg(undefined);
        onClose(false);
    };
    return MuiHelpers_createElement(Dialog, [["open", isOpen], ["onClose", (delegateArg, delegateArg_1) => {
        handleClose();
    }], (elements_3 = [MuiHelpers_createElement(DialogTitle, [["children", `Slett mappe "${folder.NameNO}"`]]), MuiHelpers_createElement(DialogContent, [(elements = [createElement("p", {
        children: ["Er du sikker på at du vil slette denne kategorien?"],
    }), errorBanner(errMsg, () => {
        setErrMsg(undefined);
    })], ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(DialogActions, [(elements_2 = [MuiHelpers_createElement(Button, [["onClick", (_arg_4) => {
        handleClose();
    }], ["children", "Avbryt"]]), MuiHelpers_createElement(Button, [["onClick", (_arg_5) => {
        let properties_2;
        setProcessing(true);
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = undefined;
        try {
            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(`/api/document-tree/admin/${folder.Id}`, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_1.then((res) => {
            if (res.tag === 0) {
                const msg_1 = res.fields[0];
                if (msg_1.Result === "success") {
                    onClose(true);
                }
                else {
                    console.error(some("Something went wrong:"), msg_1);
                    setErrMsg("Kunne ikke slette mappe. Vennligst prøv igjen senere.");
                }
            }
            else {
                setErrMsg("Kunne ikke slette mappe. Vennligst prøv igjen senere.");
            }
            setProcessing(false);
        });
    }], ["disabled", processing ? true : (errMsg != null)], (elements_1 = toList(delay(() => append_1(processing ? singleton(loadingIndicatorSmall()) : empty_1(), delay(() => singleton(createElement("span", {
        children: ["Slett"],
    })))))), ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
}

export function Branch_SupplierFolderForm_Z3DFDA5BB(branch_SupplierFolderForm_Z3DFDA5BBInputProps) {
    let elements_4, children_2, elems_8, elems_4, elems_3, elements, props_3, elems_1, elems_2, elems_7, children_3;
    const version = branch_SupplierFolderForm_Z3DFDA5BBInputProps.version;
    const onClose = branch_SupplierFolderForm_Z3DFDA5BBInputProps.onClose;
    const parent = branch_SupplierFolderForm_Z3DFDA5BBInputProps.parent;
    const machineId = branch_SupplierFolderForm_Z3DFDA5BBInputProps.machineId;
    const isOpen = branch_SupplierFolderForm_Z3DFDA5BBInputProps.isOpen;
    const key = branch_SupplierFolderForm_Z3DFDA5BBInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    let patternInput_2;
    const initial_2 = emptyCategory(version, parent);
    patternInput_2 = reactApi.useState(initial_2);
    const updateForm = patternInput_2[1];
    const branchForm = patternInput_2[0];
    const patternInput_3 = reactApi.useState(0);
    const textLang = patternInput_3[0] | 0;
    const nameNoRef = reactApi.useRef(undefined);
    const nameEnRef = reactApi.useRef(undefined);
    const descNoRef = reactApi.useRef(undefined);
    const descEnRef = reactApi.useRef(undefined);
    return MuiHelpers_createElement(Dialog, [["style", {}], ["maxWidth", "sm"], ["open", isOpen], ["onClose", (_arg_3, v) => {
        console.debug("Closing");
        setErrMsg(undefined);
        onClose(undefined);
    }], (elements_4 = [MuiHelpers_createElement(DialogTitle, [["children", "Legg til leverandør"]]), (children_2 = ofArray([createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems_8 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 20 + "px",
    }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        rowGap: 10 + "px",
    }], (elems_3 = [MuiHelpers_createElement(Tabs, [["style", {
        maxWidth: 100 + "%",
    }], ["variant", "fullWidth"], ["indicatorColor", "primary"], ["textColor", "primary"], ["centered", true], ["value", textLang], ["onChange", (_arg_4, v_1) => {
        patternInput_3[1](v_1);
    }], (elements = [MuiHelpers_createElement(Tab, [["label", "Norsk"]]), MuiHelpers_createElement(Tab, [["icon", isNullOrWhiteSpace(branchForm.NameEN) ? ((props_3 = {}, react.createElement(Warning, props_3))) : defaultOf_1()], ["label", "English"]])], ["children", reactApi.Children.toArray(Array.from(elements))])]), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1((textLang !== 0) ? singleton(["display", "none"]) : singleton(["display", "flex"]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => singleton(["rowGap", 10 + "px"]))))))))], (elems_1 = [nameInputWithRef("Kategorinavn", "no-name-input", branchForm.NameNO, nameNoRef), descriptionInput("no-desc-input", "Norsk beskrivelse", branchForm.DescNO, descNoRef)], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1((textLang !== 1) ? singleton(["display", "none"]) : singleton(["display", "flex"]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => singleton(["rowGap", 10 + "px"]))))))))], (elems_2 = [nameInputWithRef("Kategorinavn", "en-name-input", branchForm.NameEN, nameEnRef), descriptionInput("en-desc-input", "Engelsk beskrivelse", branchForm.DescEN, descEnRef)], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
    }], (elems_7 = toList(delay(() => append_1(singleton(categoryCheckbox("category-enabled-checkbox", ctx.Locale.t("DocumentTree.Admin.Enable"), (b) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, b, branchForm.PtgOnly, branchForm.AllowUpload, branchForm.AllowMachineSubCategories, branchForm.NameNO, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }, branchForm.Enabled)), delay(() => append_1(singleton(categoryCheckbox("ptg-only-checkbox", ctx.Locale.t("DocumentTree.Admin.VisibilityPtgOnly"), (b_1) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, branchForm.Enabled, b_1, branchForm.AllowUpload, branchForm.AllowMachineSubCategories, branchForm.NameNO, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }, branchForm.PtgOnly)), delay(() => append_1(singleton(categoryCheckbox("allow-upload-checkbox", "Direkte opplastning", (b_2) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, branchForm.Enabled, branchForm.PtgOnly, b_2, branchForm.AllowMachineSubCategories, branchForm.NameNO, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }, branchForm.AllowUpload)), delay(empty_1)))))))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), errorBanner(patternInput_1[0], () => {
        setErrMsg(undefined);
    })]), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children_2))]])), (children_3 = toList(delay(() => (patternInput[0] ? singleton(loadingIndicatorSmall()) : append_1(singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_6) => {
        console.debug("Canceled add");
        setErrMsg(undefined);
        onClose(undefined);
    }]])), delay(() => singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["children", ctx.Locale.t("Add")], ["onClick", (_arg_7) => {
        let properties_2;
        const req = branchForm;
        const form = new DocumentCategory(req.Id, req.ParentId, req.Version, machineId, req.Enabled, req.PtgOnly, req.AllowUpload, req.AllowMachineSubCategories, getRefValue(nameNoRef), getRefValue(nameEnRef), getRefValue(descNoRef), getRefValue(descEnRef), req.SyncRules);
        if (isNullOrWhiteSpace(form.NameEN) ? true : isNullOrWhiteSpace(form.NameNO)) {
            setErrMsg("Begge navnene må bli fylt ut");
        }
        else {
            setProcessing(true);
            let pr_1;
            const body = Auto_generateBoxedEncoder_437914C6(DocumentCategory_$reflection(), undefined, undefined, undefined)(form);
            const decoder = Auto_generateBoxedDecoder_Z6670B51(DocumentCategory_$reflection(), undefined, undefined);
            const data_1 = some(body);
            const caseStrategy_3 = undefined;
            const extra_3 = undefined;
            try {
                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/document-tree/admin", properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(DocumentCategory_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_1.then((res) => {
                if (res.tag === 1) {
                    setErrMsg("Kunne ikke legge til leverandørmappe. Vennligst prøv igjen senere.");
                }
                else {
                    const newSupplierCategory = res.fields[0];
                    console.debug("Got from branch form commit", newSupplierCategory);
                    setErrMsg(undefined);
                    onClose(newSupplierCategory);
                }
                setProcessing(false);
            });
        }
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_3))]]))], ["children", reactApi.Children.toArray(Array.from(elements_4))])]);
}

export function Branch_EditSupplierForm_6F5D3B23(branch_EditSupplierForm_6F5D3B23InputProps) {
    let elems_4, elems_3, elements, props_2, elems_1, elems_2, elems_5, elements_4, elements_1, elements_3, elements_2;
    const onClose = branch_EditSupplierForm_6F5D3B23InputProps.onClose;
    const folder = branch_EditSupplierForm_6F5D3B23InputProps.folder;
    const isOpen = branch_EditSupplierForm_6F5D3B23InputProps.isOpen;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(folder);
    const updateForm = patternInput[1];
    const branchForm = patternInput[0];
    const patternInput_1 = reactApi.useState(0);
    const textLang = patternInput_1[0] | 0;
    const nameNoRef = reactApi.useRef(undefined);
    const nameEnRef = reactApi.useRef(undefined);
    const descNoRef = reactApi.useRef(undefined);
    const descEnRef = reactApi.useRef(undefined);
    const patternInput_2 = reactApi.useState(false);
    const setProcessing = patternInput_2[1];
    const processing = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setErrMsg = patternInput_3[1];
    const errMsg = patternInput_3[0];
    const handleClose = () => {
        setErrMsg(undefined);
        onClose(folder);
    };
    const textInputFields = createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 20 + "px",
    }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        rowGap: 10 + "px",
    }], (elems_3 = [MuiHelpers_createElement(Tabs, [["style", {
        maxWidth: 100 + "%",
    }], ["variant", "fullWidth"], ["indicatorColor", "primary"], ["textColor", "primary"], ["centered", true], ["value", textLang], ["onChange", (_arg_2, v) => {
        patternInput_1[1](v);
    }], (elements = [MuiHelpers_createElement(Tab, [["label", "Norsk"]]), MuiHelpers_createElement(Tab, [["icon", isNullOrWhiteSpace(branchForm.NameEN) ? ((props_2 = {}, react.createElement(Warning, props_2))) : defaultOf_1()], ["label", "English"]])], ["children", reactApi.Children.toArray(Array.from(elements))])]), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1((textLang !== 0) ? singleton(["display", "none"]) : singleton(["display", "flex"]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => singleton(["rowGap", 10 + "px"]))))))))], (elems_1 = [nameInputWithRef("Kategorinavn", "no-name-input", branchForm.NameNO, nameNoRef), descriptionInput("no-desc-input", "Norsk beskrivelse", branchForm.DescNO, descNoRef)], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1((textLang !== 1) ? singleton(["display", "none"]) : singleton(["display", "flex"]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => singleton(["rowGap", 10 + "px"]))))))))], (elems_2 = [nameInputWithRef("Kategorinavn", "en-name-input", branchForm.NameEN, nameEnRef), descriptionInput("en-desc-input", "Engelsk beskrivelse", branchForm.DescEN, descEnRef)], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    const settingsCheckboxes = createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
    }], (elems_5 = [categoryCheckbox("category-enabled-checkbox", ctx.Locale.t("DocumentTree.Admin.Enable"), (b) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, b, branchForm.PtgOnly, branchForm.AllowUpload, branchForm.AllowMachineSubCategories, branchForm.NameNO, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }, branchForm.Enabled), categoryCheckbox("ptg-only-checkbox", ctx.Locale.t("DocumentTree.Admin.VisibilityPtgOnly"), (b_1) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, branchForm.Enabled, b_1, branchForm.AllowUpload, branchForm.AllowMachineSubCategories, branchForm.NameNO, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }, branchForm.PtgOnly), categoryCheckbox("allow-upload-checkbox", "Direkte opplastning", (b_2) => {
        updateForm(new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, branchForm.Enabled, branchForm.PtgOnly, b_2, branchForm.AllowMachineSubCategories, branchForm.NameNO, branchForm.NameEN, branchForm.DescNO, branchForm.DescEN, branchForm.SyncRules));
    }, branchForm.AllowUpload)], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
    return MuiHelpers_createElement(Dialog, [["open", isOpen], ["onClose", (delegateArg, delegateArg_1) => {
        handleClose();
    }], (elements_4 = [MuiHelpers_createElement(DialogTitle, [["children", `Oppdater mappe "${folder.NameNO}"`]]), MuiHelpers_createElement(DialogContent, [(elements_1 = [textInputFields, settingsCheckboxes, errorBanner(errMsg, () => {
        setErrMsg(undefined);
    })], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(DialogActions, [(elements_3 = [MuiHelpers_createElement(Button, [["onClick", (_arg_5) => {
        handleClose();
    }], ["children", "Avbryt"]]), MuiHelpers_createElement(Button, [["onClick", (_arg_6) => {
        let properties_2;
        const form = new DocumentCategory(branchForm.Id, branchForm.ParentId, branchForm.Version, branchForm.MachineId, branchForm.Enabled, branchForm.PtgOnly, branchForm.AllowUpload, branchForm.AllowMachineSubCategories, getRefValue(nameNoRef), getRefValue(nameEnRef), getRefValue(descNoRef), getRefValue(descEnRef), branchForm.SyncRules);
        if (isNullOrWhiteSpace(form.NameEN) ? true : isNullOrWhiteSpace(form.NameNO)) {
            setErrMsg("Begge navnene må bli fylt ut");
        }
        else {
            setProcessing(true);
            let pr_1;
            const data = some(Auto_generateBoxedEncoder_437914C6(DocumentCategory_$reflection(), undefined, undefined, undefined)(form));
            const decoder = Auto_generateBoxedDecoder_Z6670B51(DocumentCategory_$reflection(), undefined, undefined);
            const data_1 = data;
            const caseStrategy_3 = undefined;
            const extra_3 = undefined;
            try {
                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/document-tree/admin", properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(DocumentCategory_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_1.then((res) => {
                if (res.tag === 0) {
                    onClose(res.fields[0]);
                }
                else {
                    console.error(some("Failed updating category/folder"), res.fields[0]);
                    setErrMsg("Kunne ikke oppdatere mappe. Vennligst prøv igjen senere.");
                }
                setProcessing(false);
            });
        }
    }], ["disabled", processing ? true : (errMsg != null)], (elements_2 = toList(delay(() => append_1(processing ? singleton(loadingIndicatorSmall()) : empty_1(), delay(() => singleton(createElement("span", {
        children: ["Oppdater"],
    })))))), ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elements_4))])]);
}

export function Branch_DeleteFolderButton_32A5F3E1(branch_DeleteFolderButton_32A5F3E1InputProps) {
    let elements, props_1;
    const onDelete = branch_DeleteFolderButton_32A5F3E1InputProps.onDelete;
    const folder = branch_DeleteFolderButton_32A5F3E1InputProps.folder;
    const patternInput = reactApi.useState(false);
    const setOpen = patternInput[1];
    const isOpen = patternInput[0];
    const xs = [createElement(Branch_DeleteFolderForm_145C481D, {
        isOpen: isOpen,
        folder: folder,
        onClose: (didDelete) => {
            if (didDelete) {
                onDelete();
                setOpen(false);
            }
        },
    }), MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
        setOpen(!isOpen);
    }], ["size", "small"], (elements = [(props_1 = {}, react.createElement(Delete, props_1))], ["children", reactApi.Children.toArray(Array.from(elements))])])];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function Branch_EditSupplierButton_2306A009(branch_EditSupplierButton_2306A009InputProps) {
    let elements, props_1;
    const onFormClose = branch_EditSupplierButton_2306A009InputProps.onFormClose;
    const folder = branch_EditSupplierButton_2306A009InputProps.folder;
    const patternInput = reactApi.useState(false);
    const setOpen = patternInput[1];
    const isOpen = patternInput[0];
    const xs = [createElement(Branch_EditSupplierForm_6F5D3B23, {
        isOpen: isOpen,
        folder: folder,
        onClose: (updatedOpt) => {
            onFormClose(updatedOpt);
            setOpen(false);
        },
    }), MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
        setOpen(!isOpen);
    }], ["size", "small"], (elements = [(props_1 = {}, react.createElement(Edit, props_1))], ["children", reactApi.Children.toArray(Array.from(elements))])])];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function Changelog_Table_727DA32F(changelog_Table_727DA32FInputProps) {
    let elements_7, children_1, elements_1, children_2, children_3, elements_5;
    const categories = changelog_Table_727DA32FInputProps.categories;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const patternInput_1 = reactApi.useState([]);
    const logs = patternInput_1[0];
    const patternInput_2 = reactApi.useState(0);
    const setPage = patternInput_2[1];
    const page = patternInput_2[0] | 0;
    const patternInput_3 = reactApi.useState(10);
    const rowsPerPage = patternInput_3[0] | 0;
    const rowsPerPageOptions = new Int32Array([5, 10, 15, 20]);
    const orderCount = logs.length | 0;
    const rowsToSkip = (page * rowsPerPage) | 0;
    const rowsToTake = ((orderCount < (rowsToSkip + rowsPerPage)) ? (orderCount - rowsToSkip) : rowsPerPage) | 0;
    const sorted = sortByDescending((log) => log.Log.EditDate, logs, {
        Compare: compare,
    });
    const logsSegment = sorted.slice(rowsToSkip, (rowsToSkip + rowsToTake) + 1);
    const dependencies = [categories];
    reactApi.useEffect(() => {
        let properties_2;
        setLoading(true);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(DocumentTreeAuditLog_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/document-tree/admin/audits", properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(DocumentTreeAuditLog_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                patternInput_1[1](res.fields[0]);
            }
            else {
                throw new Error("todo");
            }
            setLoading(false);
        });
    }, dependencies);
    const headerCell = (name) => MuiHelpers_createElement(TableCell, [["children", name]]);
    const cell = (children) => MuiHelpers_createElement(TableCell, [["style", {
        whiteSpace: "nowrap",
    }], ["children", reactApi.Children.toArray(Array.from(children))]]);
    return MuiHelpers_createElement(Table, [(elements_7 = [(children_1 = singleton_1(MuiHelpers_createElement(TableRow, [(elements_1 = [headerCell("Handling"), headerCell("Type"), headerCell("Id"), headerCell("Endringer"), headerCell("Bruker"), headerCell("Dato")], ["children", reactApi.Children.toArray(Array.from(elements_1))])])), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_2 = toList(delay(() => (patternInput[0] ? skeletonRows(6, 10) : singleton(map_1((_arg_2) => {
        let matchValue_4, clo_4, clo, elements_3;
        const treeOpt = _arg_2.TreeOpt;
        const log_1 = _arg_2.Log;
        const action = AuditLogs_Actions_FromId(log_1.Action);
        let entityTypeName;
        if (ctx.Language.tag === 1) {
            const matchValue_3 = log_1.Entity;
            entityTypeName = ((matchValue_3 === "DocumentTree") ? "Category" : ((matchValue_3 === "DocumentTreeVersion") ? "Version" : "Wrong type"));
        }
        else {
            const matchValue_2 = log_1.Entity;
            entityTypeName = ((matchValue_2 === "DocumentTree") ? "Kategori" : ((matchValue_2 === "DocumentTreeVersion") ? "Versjon" : "Feil type"));
        }
        const entityId = (treeOpt != null) ? value_97(treeOpt).NameNO : ((_arg_2.TreeVersionOpt != null) ? log_1.EntityId : log_1.EntityId);
        let changes;
        const columnName = defaultArg(map((matchValue_4 = log_1.Entity, (matchValue_4 === "DocumentTree") ? ((arg_1) => DocumentTrees_Audit_toString(ctx.Language, arg_1)) : ((matchValue_4 === "DocumentTreeVersion") ? ((arg_2) => DocumentTreeVersions_Audit_toString(ctx.Language, arg_2)) : ((_arg_3) => "ERROR"))), log_1.ColumnId), "");
        if (ctx.Language.tag === 1) {
            switch (action.tag) {
                case 2: {
                    changes = "Delete";
                    break;
                }
                case 1: {
                    changes = toText(printf("%s from \"%s\" to %s\""))(columnName)(log_1.OldValue)(log_1.NewValue);
                    break;
                }
                default: {
                    const createFormRes_1 = fromString_1(uncurry2(Auto_generateBoxedDecoder_Z6670B51(DocumentCategory_$reflection(), undefined, undefined)), log_1.NewValue);
                    if (createFormRes_1.tag === 1) {
                        changes = "Create";
                    }
                    else {
                        const form_1 = createFormRes_1.fields[0];
                        changes = (`Create category "${form_1.NameNO}" in ${defaultArg(map((clo_4 = toText(printf("version %i")), clo_4), form_1.Version), "the original version")}`);
                    }
                }
            }
        }
        else {
            switch (action.tag) {
                case 2: {
                    changes = "Slett";
                    break;
                }
                case 1: {
                    changes = toText(printf("%s fra \"%s\" til \"%s\""))(columnName)(log_1.OldValue)(log_1.NewValue);
                    break;
                }
                default: {
                    const createFormRes = fromString_1(uncurry2(Auto_generateBoxedDecoder_Z6670B51(DocumentCategory_$reflection(), undefined, undefined)), log_1.NewValue);
                    changes = ((createFormRes.tag === 1) ? "Opprett" : (`Opprett kategori i ${defaultArg(map((clo = toText(printf("versjon %i")), clo), createFormRes.fields[0].Version), "original versjon")}`));
                }
            }
        }
        return MuiHelpers_createElement(TableRow, [["key", `${toShortDateString(log_1.EditDate)}-${toLongTimeString(log_1.EditDate)}-${log_1.Action}-${log_1.ColumnId}-${log_1.OldValue}-${log_1.NewValue}`], (elements_3 = [cell([actionStr(ctx.Language, action)]), cell([entityTypeName]), cell([entityId]), cell([changes]), cell(toArray(delay(() => {
            const matchValue_6 = log_1.Editor;
            if (matchValue_6 != null) {
                const account = matchValue_6;
                return singleton(createElement("a", {
                    href: `mailto:${account.Email}`,
                    children: toText(printf("%s %s"))(account.FirstName)(account.LastName),
                }));
            }
            else {
                return singleton("systemet");
            }
        }))), cell([toDateAndTimeStr(ctx.DateFnsLocale, log_1.EditDate)])], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
    }, logsSegment))))), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_2))]])), (children_3 = singleton_1(MuiHelpers_createElement(TableRow, [(elements_5 = [MuiHelpers_createElement(TablePagination, [["colSpan", 6], ["page", page], ["rowsPerPage", rowsPerPage], ["count", logs.length], ["onPageChange", ((arg10$0040, newPage) => {
        onPageChange(setPage, arg10$0040, newPage);
    })], ["rowsPerPage", rowsPerPage], ["rowsPerPageOptions", Array.from(rowsPerPageOptions)], ["onRowsPerPageChange", (ev) => {
        const newRowsPerPage = ev.target.value | 0;
        setPage(0);
        patternInput_3[1](newRowsPerPage);
    }]])], ["children", reactApi.Children.toArray(Array.from(elements_5))])])), MuiHelpers_createElement(TableFooter, [["children", reactApi.Children.toArray(Array.from(children_3))]]))], ["children", reactApi.Children.toArray(Array.from(elements_7))])]);
}

/**
 * Clickable controlled document category list
 */
export function Versions_List_Z2855D50(versions_List_Z2855D50InputProps) {
    let elements_2, children_2, children_3, elems_7, elements_6;
    const onVersionSelect = versions_List_Z2855D50InputProps.onVersionSelect;
    const versions = versions_List_Z2855D50InputProps.versions;
    const currentVersion = versions_List_Z2855D50InputProps.currentVersion;
    const loading = versions_List_Z2855D50InputProps.loading;
    const initialVersionItem = MuiHelpers_createElement(ListItem, [["key", "initial"], ["onClick", (_arg) => {
        onVersionSelect(undefined);
    }], ["button", true], ["selected", currentVersion == null], (elements_2 = [(children_2 = toList(delay(() => {
        let props_1, props_3;
        return (currentVersion == null) ? singleton((props_1 = {}, react.createElement(Star, props_1))) : singleton((props_3 = {}, react.createElement(StarBorder, props_3)));
    })), MuiHelpers_createElement(ListItemIcon, [["children", reactApi.Children.toArray(Array.from(children_2))]])), (children_3 = singleton_1(MuiHelpers_createElement(Typography, [["variant", "subtitle1"], ["children", "Original"]])), MuiHelpers_createElement(ListItemText, [["children", reactApi.Children.toArray(Array.from(children_3))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
    const ctx = reactApi.useContext(ctx_1);
    const versionItems = map_1((version_1) => {
        let elements_5, children_7, children_8, Id;
        const selected = (currentVersion != null) ? (version_1.Id === currentVersion.Id) : (version_1.Id === 0);
        return MuiHelpers_createElement(ListItem, [["key", version_1.Id], ["onClick", (_arg_1) => {
            onVersionSelect(version_1);
        }], ["button", true], ["selected", selected], (elements_5 = [(children_7 = toList(delay(() => {
            let props_7, props_9, props_11;
            return !version_1.Active ? singleton((props_7 = {}, react.createElement(Edit, props_7))) : (selected ? singleton((props_9 = {}, react.createElement(Star, props_9))) : singleton((props_11 = {}, react.createElement(StarBorder, props_11))));
        })), MuiHelpers_createElement(ListItemIcon, [["children", reactApi.Children.toArray(Array.from(children_7))]])), (children_8 = singleton_1(MuiHelpers_createElement(Typography, [["variant", "subtitle1"], ["children", (Id = int32ToString(version_1.Id), ctx.Locale.t("Version", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["Id", Id])))]])), MuiHelpers_createElement(ListItemText, [["children", reactApi.Children.toArray(Array.from(children_8))]]))], ["children", reactApi.Children.toArray(Array.from(elements_5))])]);
    }, sortBy((version) => version.Id, versions, {
        Compare: comparePrimitives,
    }));
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 10 + "px",
    }], (elems_7 = [createElement("p", {
        children: [ctx.Locale.t("Versions")],
    }), MuiHelpers_createElement(List, [["dense", true], (elements_6 = (loading ? skeletonList(5) : append([initialVersionItem], versionItems)), ["children", reactApi.Children.toArray(Array.from(elements_6))])])], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

export function Versions_MachineSelect_171BBDF2(versions_MachineSelect_171BBDF2InputProps) {
    let elems, elements_2, array_4, elements_1;
    const onSelect = versions_MachineSelect_171BBDF2InputProps.onSelect;
    const machineId = versions_MachineSelect_171BBDF2InputProps.machineId;
    const current = versions_MachineSelect_171BBDF2InputProps.current;
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const loading = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setSelected = patternInput_1[1];
    const patternInput_2 = reactApi.useState([]);
    const versions = patternInput_2[0];
    useEffectOnce(() => {
        let properties_6;
        setLoading(true);
        let pr_4;
        let pr_3;
        const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(array_type(DocumentTreeVersion_$reflection()), undefined, undefined);
        const data_5 = undefined;
        const caseStrategy_11 = undefined;
        const extra_11 = extraCoders;
        try {
            const properties_3_1 = Helper_withProperties(undefined, (properties_6 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_11), unwrap(extra_11))(data_1_2))]), properties_6), data_5), properties_6)));
            const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/document-tree/admin/versions", properties_3_1).then((_arg_2) => {
                let response_3, decoder_1_2;
                return ((response_3 = _arg_2, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(array_type(DocumentTreeVersion_$reflection()), unwrap(caseStrategy_11), unwrap(extra_11))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_3.text().then((_arg_3) => {
                    let matchValue_1;
                    return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_3), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
            }))));
            pr_3 = (pr_2.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])])))));
        }
        catch (exn_1) {
            pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
        }
        pr_4 = (pr_3.then((result_2) => Result_MapError(testRedirect, result_2)));
        pr_4.then((res_1) => {
            if (res_1.tag === 0) {
                const versions_1 = res_1.fields[0];
                patternInput_2[1](versions_1);
                setSelected(tryPick((version_1) => {
                    if (equals(version_1.Id, current)) {
                        return version_1.Id;
                    }
                    else {
                        return undefined;
                    }
                }, versions_1));
            }
            else {
                console.error(some("Failed fetching versions"), res_1.fields[0]);
            }
            setLoading(false);
        });
    });
    return MuiHelpers_createElement(Select, [["classes.select", "flex"], ["fullWidth", true], ["disabled", loading], ["value", orElse(patternInput_1[0], -1)], ["onChange", (e, _arg_4) => {
        let properties_2;
        const newVersion_1 = e.target.value;
        console.debug("Selected new version:", newVersion_1);
        const newVersionId = map((version) => version.Id, tryFind((version_2) => (version_2.Id === newVersion_1), versions));
        const url = API_Machine_CategoryVersion(machineId) + generateQueryString([["version", int32ToString(defaultArg(newVersionId, -1))]]);
        setLoading(true);
        let pr_1;
        const data = some(Auto_generateBoxedEncoder_437914C6(unit_type, undefined, undefined, undefined)());
        const decoder = Auto_generateBoxedDecoder_Z6670B51(unit_type, undefined, undefined);
        const data_1 = data;
        const caseStrategy_3 = undefined;
        const extra_3 = undefined;
        try {
            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(unit_type, unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => (Promise.resolve(new FSharpResult$2(0, [void undefined]))))))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_1.then((res) => {
            if (res.tag === 0) {
                setSelected(newVersionId);
            }
            else {
                throw new Error("todo");
            }
            setLoading(false);
        });
    }], ["startAdornment", !loading ? defaultOf_1() : createElement("div", createObj(ofArray([["style", {
        marginRight: 10 + "px",
    }], (elems = [loadingIndicatorSmall()], ["children", reactApi.Children.toArray(Array.from(elems))])])))], (elements_2 = [(array_4 = map_1((version_4) => {
        let elements;
        return MuiHelpers_createElement(MenuItem, [["value", version_4.Id], (elements = [MuiHelpers_createElement(Typography, [["children", `Versjon ${version_4.Id}`]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
    }, versions), append([MuiHelpers_createElement(MenuItem, [["value", -1], (elements_1 = [MuiHelpers_createElement(Typography, [["children", "Original"]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], array_4))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

/**
 * Uncontrolled document category select menu
 */
export function Versions_Select_4E1E58D2(versions_Select_4E1E58D2InputProps) {
    let elements_3, elements_2, array_4, elements_1;
    const onSelect = versions_Select_4E1E58D2InputProps.onSelect;
    const setLoading = reactApi.useState(false)[1];
    const patternInput_1 = reactApi.useState(undefined);
    const patternInput_2 = reactApi.useState([]);
    const versions = patternInput_2[0];
    const activeIdOpt = (versions.length === 0) ? undefined : maxBy((v) => {
        if (v.Active) {
            return v.Id | 0;
        }
        else {
            return -1;
        }
    }, versions, {
        Compare: comparePrimitives,
    }).Id;
    reactApi.useEffect(() => {
        let properties_2;
        setLoading(true);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(DocumentTreeVersion_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/document-tree/admin/versions", properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(DocumentTreeVersion_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                patternInput_2[1](res.fields[0]);
            }
            else {
                console.error(some("Failed fetching versions"), res.fields[0]);
            }
            setLoading(false);
        });
    }, []);
    return MuiHelpers_createElement(FormControl, [["fullWidth", true], (elements_3 = [MuiHelpers_createElement(Select, [["classes.select", "flex"], ["fullWidth", true], ["value", orElse(map((version_1) => version_1.Id, patternInput_1[0]), -1)], ["onChange", (e, _arg_2) => {
        const newVersion = e.target.value;
        console.debug("Selected new version:", newVersion);
        const versionOpt = tryFind((version_2) => (version_2.Id === newVersion), versions);
        onSelect(versionOpt);
        patternInput_1[1](versionOpt);
    }], (elements_2 = [(array_4 = map_1((version_3) => {
        let elements;
        return MuiHelpers_createElement(MenuItem, [["value", version_3.Id], (elements = [MuiHelpers_createElement(Typography, [["children", `Versjon ${version_3.Id}`]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
    }, versions), append([MuiHelpers_createElement(MenuItem, [["value", -1], (elements_1 = [MuiHelpers_createElement(Typography, [["children", "Original"]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], array_4))], ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
}

/**
 * Controlled document version select menu
 */
export function Versions_Select_Z3AED8366(versions_Select_Z3AED8366InputProps) {
    let elements_4, array_4, elements_3, children_5, props_9;
    const onSelect = versions_Select_Z3AED8366InputProps.onSelect;
    const versions = versions_Select_Z3AED8366InputProps.versions;
    const currentVersion = versions_Select_Z3AED8366InputProps.currentVersion;
    const activeIdOpt = (versions.length === 0) ? undefined : maxBy((v) => {
        if (v.Active) {
            return v.Id | 0;
        }
        else {
            return -1;
        }
    }, versions, {
        Compare: comparePrimitives,
    }).Id;
    return MuiHelpers_createElement(Select, [["classes.select", "flex"], ["fullWidth", true], ["value", orElse(map((version_1) => version_1.Id, currentVersion), -1)], ["onChange", (e, _arg) => {
        const newVersion = e.target.value;
        console.debug("Selected new version:", newVersion);
        onSelect(tryFind((version_2) => (version_2.Id === newVersion), versions));
    }], (elements_4 = [(array_4 = map_1((version_3) => {
        let elements_1, children_3;
        return MuiHelpers_createElement(MenuItem, [["value", version_3.Id], (elements_1 = [(children_3 = toList(delay(() => {
            let props_1, props_3, props_5;
            return !version_3.Active ? singleton((props_1 = {}, react.createElement(Edit, props_1))) : (equals(version_3.Id, activeIdOpt) ? singleton((props_3 = {}, react.createElement(Star, props_3))) : singleton((props_5 = {}, react.createElement(StarBorder, props_5))));
        })), MuiHelpers_createElement(ListItemIcon, [["children", reactApi.Children.toArray(Array.from(children_3))]])), MuiHelpers_createElement(Typography, [["children", `Versjon ${version_3.Id}`]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]);
    }, versions), append([MuiHelpers_createElement(MenuItem, [["value", -1], (elements_3 = [(children_5 = singleton_1((props_9 = {}, react.createElement(StarBorder, props_9))), MuiHelpers_createElement(ListItemIcon, [["children", reactApi.Children.toArray(Array.from(children_5))]])), MuiHelpers_createElement(Typography, [["children", "Original"]])], ["children", reactApi.Children.toArray(Array.from(elements_3))])])], array_4))], ["children", reactApi.Children.toArray(Array.from(elements_4))])]);
}

